/**
 * Страницы-заглушки разделов. Каркас навигации готов; наполнение каждого раздела приходит
 * со своим эпиком — здесь показываем заголовок и честное «раздела пока нет», чтобы скелет
 * был сквозным (вход → навигация → раздел), но не имитировал несуществующие данные.
 *
 * ТЕКСТ — ДЛЯ ПОЛЬЗОВАТЕЛЯ, А НЕ ДЛЯ НАС (решение владельца 05.08.2026). Внутренние
 * обозначения задач — «SK-5», «эпик E12» — на экран не выносятся: юристу и бухгалтеру они
 * ничего не говорят, а выглядят как ошибка. Что раздел даст и что его пока нет — этого
 * достаточно; номер эпика остаётся в коде комментарием и в docs/04.
 */

export interface SectionMeta {
  readonly title: string;
  /** Короткое пояснение простым языком: что здесь будет. Без внутренних обозначений. */
  readonly note: string;
}

/** Пояснения по разделам навигации (ключ — id из NAV_ITEMS). */
export const SECTION_META: Record<string, SectionMeta> = {
  contracts: {
    title: "Договоры",
    // Раздел реализован (ContractsPage): список из БД, карточку добавил E5. Запись оставлена
    // как справочная — в маршрутизации contracts отдаёт свою страницу, не заглушку.
    note: "Реестр договоров.",
  },
  // Наполнен E11 (RegisterPage): отправка комплекта на разбор и очередь черновиков. Запись
  // оставлена справочной — в маршрутизации register отдаёт свою страницу, не заглушку.
  register: {
    title: "Регистрация",
    note: "Загрузка сканов договора и автоматический разбор: система предлагает список обязательств, юрист их проверяет.",
  },
  // Наполнен E11 (VerifyPage): проверка разбора и постановка на контроль. Запись справочная —
  // в маршрутизации verify отдаёт свою страницу, не заглушку.
  verify: {
    title: "Верификация",
    note: "Проверка юристом предложенных обязательств перед постановкой на контроль.",
  },
  // Наполняют E1, E3, E15.
  settings: {
    title: "Настройки",
    note: "Справочники (производственный календарь, ключевая ставка Банка России), пользователи и реквизиты организации.",
  },
};

export function SectionPlaceholder({ meta }: { meta: SectionMeta }) {
  return (
    <section aria-labelledby="section-title">
      <h1 id="section-title" className="text-[20px] font-bold text-ink">
        {meta.title}
      </h1>
      <div className="mt-4 rounded-[var(--radius-l)] border border-border bg-surface p-5 text-muted">
        <p className="max-w-[var(--w-text)]">{meta.note}</p>
        <p className="mt-3 text-[13px]">Раздел появится в одном из ближайших обновлений.</p>
      </div>
    </section>
  );
}
